import type { CredentialVerification } from '@terra/shared-schemas-orchestrator';
import type { z } from 'zod';
import type {
  CredentialsApiSchema,
  CredentialsVerificationSsePayload,
  VerificationArtifactDto,
} from '@terra/shared-contracts-applications';

export type BackendCredential = z.infer<
  typeof CredentialsApiSchema
>['credentials'][number];

export type RestCredentialVerification = CredentialVerification & {
  authMaterialExpiry?: CredentialsVerificationSsePayload['verification']['authMaterialExpiry'];
  artifacts?: VerificationArtifactDto[];
};

export const getDecryptedCredentialsQueryKey = (applicationId: string) =>
  ['application-credentials', applicationId, 'decrypted'] as const;

export const toRestVerification = (
  verification: CredentialsVerificationSsePayload['verification'],
): RestCredentialVerification => ({
  status: verification.status,
  lastError: verification.lastError,
  lastAttemptAt: verification.lastAttemptAt
    ? new Date(verification.lastAttemptAt)
    : null,
  verifiedAt: verification.verifiedAt
    ? new Date(verification.verifiedAt)
    : null,
  authMaterialExpiry: verification.authMaterialExpiry ?? null,
  artifacts: verification.artifacts,
});
